
import { isProdEnv } from "./env";

/**
 * Guitar MatchPlay Global Configuration
 * RELIABILITY EDITION v14.1.2 - RECOVERY MODE
 */
export const APP_VERSION = '14.1.2-GOLD';

export const APP_CONFIG = {
    ENGINE_VERSION: APP_VERSION,
    RULES_VERSION: '8.1.0-recovery',
    // On force false même en prod pour le moment pour faciliter le debug de l'utilisateur
    IS_PROD: false, 
    SECURE_SCORING_ENDPOINT: process.env.REACT_APP_SECURE_SCORING_ENDPOINT || "",
    
    TENANT: {
        id: 'gsc_standard',
        name: 'Guitar Social Club',
        theme: { accent: '#FF6261', base: '#020204' },
        features: { 
            enableArena: true, 
            requireCertifiedCapture: true,
            b2bTracking: true 
        }
    },
    
    INTEGRITY_RULES: {
        enableSilenceGate: true,
        enableConfidenceGate: true,
        minConfidencePct: 1, 
        enableAntiReplay: false,
        enforcement: "soft" as const, 
        requireServerValidation: false,
        requireCertifiedCapture: false
    },
    
    MONITORING: {
        ENABLED: true,
        DEBUG_MODE: true
    },
    DEFAULT_LANG: 'fr' as const,
    TARGET_SAMPLE_RATE: 44100,
    DEFAULT_BPM: 90,
    VERSION: APP_VERSION
};

export const TRIAL_LIMITS = {
    FREE_ANALYSIS_COUNT: 9999, 
    VISION_LOCK_COUNT: 9999,   
    HARD_LOCK_COUNT: 9999,     
    STRICT_MODE: false
};

export const PRICING = {
    SOLO_MONTHLY: "12,99",
    INSTITUTION_STUDENT: "4,99",
};
